import React from 'react'
import CamionPromedio from './CamionPromedio'
import CumplimientoCupos from './CumplimientoCupos'
import EspacioDisponible from './EspacioDisponible'
import OpcionesCerealEstimacion from './OpcionesCerealEstimacion'
import DialogoCalendarioCargas from '../../../Buque/components/anunciobuques/DialogoCalendarioCargas'

function PanelConfiguracionEstimacion (props) {
  const { pesoCamion, cumplimiento, tipoSimulacion } = props

  return (
    <div
      style={{
        padding: '8px',
        borderRadius: '28px'
      }}
    >
      { tipoSimulacion === 1 && <OpcionesCerealEstimacion /> }
      <div style={{ margin: '2% 1%' }}>
        <CamionPromedio peso={pesoCamion} />
      </div>
      <div style={{ margin: '2% 1%' }}>
        <CumplimientoCupos cumplimiento={cumplimiento} />
      </div>
      { tipoSimulacion === 0 &&
        <div style={{ margin: '2% 1%' }}>
          <EspacioDisponible />
        </div>
      }

      { tipoSimulacion === 0 &&
        <div style={{ marginTop: '22px' }}>
          <DialogoCalendarioCargas />
        </div>
      }
    </div>
  )
}

export default PanelConfiguracionEstimacion
